import './App.css';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
function Slider() {
  const options = {
    animateOut: 'slideOutDown',
    animateIn: 'slideInDown',
    items: 1,
    loop: true,
    autoPlay: false,
    dots: false,
    nav: true,
    navText: ["<i class='flaticon-left-arrow'></i>", "<i class='flaticon-next'></i>"],
    autoheight: "true",
    autoplaySpeed: 800,
    mouseDrag: false,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1200: {
        items: 1,
      }
    }
  };
  return (
    <div className="slider">
      {/* <!-- Slider area --> */}
      <section className="slider-area">
        <OwlCarousel
          className="home-slider owl-carousel owl-theme"
          loop
          margin={10}
          nav
          {...options}
        >
          <div className="single-slider single-slider-bg-1">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-lg-12 text-center">
                      <div className="slider-tittle one">
                        <h1>
                          Welcome To Our School
                        </h1>
                        <p>
                          Achiever’s Hub Senior Secondary School, truly a house of achievers, warmly welcomes your child into a dynamic and enriching world of education. Our school provides a joyful, secure, and inspiring environment where young learners are encouraged to explore, grow, and excel academically as well as personally.

                          We firmly believe that every child is endowed with immense potential. When guided with care, values, and the right opportunities, this potential blossoms into excellence and success. Our dedicated approach to holistic education nurtures intellectual curiosity, moral integrity, creativity, and confidence in every student.

                          The progress and future of a nation rest upon its youth, and the quality of education they receive shapes that future. At Achiever’s Hub, we view education as a meaningful investment in the present—one that builds responsible, capable, and visionary leaders for tomorrow.
                        </p>
                      </div>
                      <div className="slider-btn bnt1 text-center">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSejO4NeMUQhZaG1N3qADhaIKwRVXgnUbIwcmr4SXR3okSLgjA/viewform" target="_blank" rel="noopener noreferrer" className="box-btn">Apply for Online Admission</a>
                        {/* <a href="special-class.html" className="border-btn">View Courses</a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="single-slider single-slider-bg-2">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-lg-12 text-center">
                      <div className="slider-tittle two">
                        <h1>Let the light come us from all the directions</h1>
                      </div>
                      <div className="slider-btn bnt2">
                        <a href="https://forms.gle/Mes9Ne7NcyxUyMnk8" target="_blank" rel="noopener noreferrer" className="box-btn">Apply for Online Admission</a>
                        {/* <a href="special-class.html" className="border-btn">View Courses</a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </OwlCarousel>
        {/* <div className="home-slider owl-carousel owl-theme">
        </div> */}
      </section>
      {/* <!-- End Slider aera --> */}
    </div>
  );
}


export default Slider;
